//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import PurchaseOrderEditedModel from '@/models/Purchase/PchPurchaseOrderEdited'
import TranslatorService from '@/services/translator'

//
import fields from './fields'

//
export default {
    name: 'purchase-order-update',
    components: {
        ModelForm,
    },
    computed: {
        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        fieldsProps() {
            return {
                is_service: this.formData.pch_purchase_order.is_service
            }
        },

        /**
         *
         */
        formProps() {
            return {
                editable: false,
                fields: fields(this.fieldsProps),
                loading: this.formBusy,
            }
        },
    },
    data() {
        return {
            formBusy: false,
            formData: {
                pch_purchase_order: {
                    is_service: false,
                }
            },
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            setErrorSnackbar: 'setErrorSnackbar',
            setInfoSnackbar: 'setInfoSnackbar',
            setSuccessSnackbar: 'setSuccessSnackbar',
            setWarningSnackbar: 'setWarningSnackbar',
        }),

        /**
         *
         */
        error(error) {
            this.setErrorSnackbar(
                TranslatorService(PurchaseOrderEditedModel, error.response.data)
            )
        },

        /**
         *
         */
        fetch() {
            PurchaseOrderEditedModel.modeler()
                .find(this.$route.params.id)
                .finally(this.toggleBusy)
                .then(this.setFormData)
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'purchase-order-list' })
        },

        /**
         *
         */
        reset() {
            this.toggleBusy().then(this.fetch)
        },

        /**
         *
         */
        setFormData(model) {
            this.formData = model.reset()
        },

        /**
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.update)
        },

        /**
         *
         */
        success() {
            this.setSuccessSnackbar('Orden de compra actualizada exitosamente.')
        },

        /**
         *
         */
        async toggleBusy() {
            this.formBusy = !this.formBusy
        },

        /**
         *
         */
        update(model) {
            model
                .toUpdate()
                .save()
                .then(this.success)
                .then(this.redirect)
                .catch(this.error)
                .then(this.$refs.form.setWait)
        },
    },
    beforeMount() {
        this.setTitleTopBar('Detalle de edición de orden de compra')
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PURCHASE_ORDER')) ctx.$router.push('/')
        })
    },
}
